import { FormLabel, Typography } from '@mui/material'

function InputMock(_props) {
  
  const {
    label = 'Please provide a label',
    value = '',
    className = ""
  } = _props
  
  return (
    <div className={"w-full flex flex-col "+className}>
      <FormLabel>{label}</FormLabel>
      <Typography variant="containedInputMock" component="div" className='min-h[2.75rem]'>
        {value}
      </Typography>
    </div>
  )
}

export default InputMock
